import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "c-loading-content"
}, null, -1);
var _hoisted_2 = [_hoisted_1];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-loading", {
      open: $props.modelValue
    }])
  }, _hoisted_2, 2);
}